<template>
	<div class="brick">
		<div style="padding-bottom: 100px; padding-top: 100px;">
			<p class="al_center">
				<b class="font_100">Data of Today: {{ status.current_date | convertYMDToMDY('/') }}</b>
			</p>
			<p class="al_center">
				<span class="font_80">Current Invoice </span>
				<span class="red_bold font_100">{{ status.current_date_value.count | commaSeparated }}</span>
				<span class="font_100 mgr_15"> / {{ daily_goal | commaSeparated }} </span>
				<span v-if="daily_goal" class="font_90 mgl_15"> {{ ((status.current_date_value.count / daily_goal) * 100) | toCurrency }}%</span>
			</p>
		</div>
		<div style="padding-bottom: 70px;">
			<p class="al_center">
				<span class="font_80">Total Invoice of this week </span>
				<span class="red_bold font_100">{{ status.duration_value.count | commaSeparated }}</span>
				<span class="font_100 mgr_15"> / {{ weekly_goal | commaSeparated }} </span>
				<span v-if="weekly_goal" class="font_90 mgl_15"> {{ ((status.duration_value.count / weekly_goal) * 100) | toCurrency }}%</span>
			</p>
			<p class="al_center mgb_20">
				<span class="font_80">{{ slogan_to_encourage }}</span>
			</p>
		</div>
		<div v-if="modifiable" style="padding-bottom: 50px;">
			<table v-if="isModify" class="view_tbl" style="margin: 0 auto;  width: 1200px;">
				<colgroup>
					<col style="width: 20%;" />
					<col style="width: 30%;" />
					<col style="width: 25%;" />
					<col style="width: 25%;" />
				</colgroup>
				<tbody>
					<tr>
						<td class="font_40">Daily Goal:</td>
						<td>
							<currency-input type="text" style="width:200px; height: 40px;" v-model.trim="daily_goal" :precision="0" :allow-negative="false" class="int_type al_right font_40" @focus="$event.target.select()" />
						</td>
						<td class="font_40">Weekly Goal:</td>
						<td>
							<currency-input type="text" style="width:200px; height: 40px;" v-model.trim="weekly_goal" :precision="0" :allow-negative="false" class="int_type al_right font_40" @focus="$event.target.select()" />
						</td>
					</tr>
					<tr>
						<td class="font_40">Slogan:</td>
						<td colspan="3">
							<input class="int_type font_40" style="width: 100%; height: 50px;" type="text" v-model.trim="slogan_to_encourage" @focus="$event.target.select()" />
						</td>
					</tr>
				</tbody>
			</table>

			<span class="right_option" style="width: 10%;">
				<a href="javascript: void(0);" class="gray_bt" @click="updateGoal()">Update GOAL</a>
			</span>
		</div>
	</div>
</template>

<script>
require('@/assets/css/layout.css');
require('@/assets/css/global.css');
import { apiStatusOfInvoiceInWeekAndToday, apiSelectStatusDisplay, apiUpdateStatusDisplay } from '@/api/report/report';
export default {
	data: () => ({
		status: {
			current_date_value: {},
			duration_value: {},
		},

		daily_goal: null,
		weekly_goal: null,
		slogan_to_encourage: null,

		isModify: false,
		interval: null,
	}),
	computed: {
		modifiable() {
			const menus = this.$session.get('menus');
			return menus.some(menu => menu.path === this.$router.history.current.path && menu.modify_yn === 'Y');
		},
	},
	methods: {
		async updateGoal() {
			if (this.isModify) {
				const { data } = await apiUpdateStatusDisplay({ information_1: this.daily_goal, information_2: this.weekly_goal, information_3: this.slogan_to_encourage });

				if (data) {
					await this.getGoalData();
					this.$toast.success('Update Goal');
				} else {
					this.$toast.error('Fail to Update Goal');
				}
			}

			this.isModify = !this.isModify;
		},
		async getGoalData() {
			const { data } = await apiSelectStatusDisplay();
			this.daily_goal = data ? Number(data.information_1) : 0;
			this.weekly_goal = data ? Number(data.information_2) : 0;
			this.slogan_to_encourage = data ? data.information_3 : '';
		},
		async getInvoiceData() {
			const { data } = await apiStatusOfInvoiceInWeekAndToday();
			this.status = data;
		},
		autoRefresh() {
			this.interval = setInterval(() => {
				this.getInvoiceData();
			}, 60 * 1000);
			// console.log(this.interval);
		},
	},
	async created() {
		await this.getInvoiceData();
		await this.getGoalData();
		this.autoRefresh();
	},
	beforeDestroy() {
		clearInterval(this.interval);
	},
};
</script>

<style scoped scss="lang">
.font_100 {
	font-size: 100px;
}
.font_90 {
	font-size: 90px;
}
.font_80 {
	font-size: 80px;
}
.font_40 {
	font-size: 40px;
}
</style>
